export default "__VITE_ASSET__afe0f9cf__"